import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { tagAbbreviation } from './tagAbbreviation';
import { cn } from '../../lib/utils';
import QualificationMark from './QualificationMark';
import { DIENSTGRAD_CONFIG } from '../../lib/dienstgrade';

export default function StaffCard({ user, onClick, isDragging, availableTags = [], roleLabel, dragHandleProps }) {
  const rank = DIENSTGRAD_CONFIG[user.dienstgrad?.toUpperCase()];
  const fullName = `${user.vorname || ''} ${user.nachname || ''}`.trim();
  const initials = [user.vorname, user.nachname].filter(Boolean).map(name => name[0]).join('');
  const userTags = (user.effective_tag_ids?.length ? user.effective_tag_ids : (user.tag_ids || []))
    .map(id => availableTags.find(tag => tag.id === id)).filter(Boolean);

  return (
    <button {...dragHandleProps} type="button" onClick={onClick} aria-label={`${fullName} – Mitarbeiterdetails öffnen`}
      className={cn(
        'group flex min-h-[104px] w-full items-stretch overflow-hidden rounded-lg bg-white text-left dark:bg-slate-900',
        'shadow-[0_1px_3px_rgba(15,23,42,0.08),0_3px_10px_rgba(15,23,42,0.05)] transition-shadow hover:shadow-md',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        isDragging && 'shadow-xl ring-2 ring-primary'
      )}>
      <div className="relative w-16 shrink-0 self-stretch overflow-hidden bg-slate-100 dark:bg-slate-800">
        <Avatar className="absolute inset-0 h-full w-full rounded-none">
          <AvatarImage src={user.avatar_url} alt={`Foto von ${fullName}`} className="aspect-auto rounded-none object-cover object-center" />
          <AvatarFallback className="rounded-none bg-slate-100 text-lg font-medium text-slate-400 dark:bg-slate-800 dark:text-slate-500">
            {initials || '—'}
          </AvatarFallback>
        </Avatar>
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
      <div className="flex min-w-0 flex-1 items-center gap-2 px-2.5 py-3">
        {rank?.image && (
          <span className="flex h-16 w-6 shrink-0 items-center justify-center">
            <img src={rank.image} alt={rank.label} title={rank.label}
              className="block max-w-none origin-center rotate-90 object-contain"
              style={{ width: 64, height: 24 }} />
          </span>
        )}
        <div className="min-w-0 flex-1" title={fullName}>
          <span className="block truncate text-xs leading-5 text-muted-foreground">{user.vorname}</span>
          <span className="block break-words text-base font-bold leading-5 tracking-tight">{user.nachname}</span>
          {roleLabel && <span className="mt-1 block text-[10px] leading-tight text-muted-foreground">{roleLabel}</span>}
          {user.dienstgrad === 'ANGESTELLT' && <span className="mt-1 block text-[10px] leading-tight text-muted-foreground">Angestellte/r</span>}
        </div>
        {user.qualifikation && user.qualifikation !== 'NONE' && (
          <span className="flex h-10 w-9 shrink-0 items-center justify-center">
            <QualificationMark qualification={user.qualifikation} />
          </span>
        )}
      </div>
      {userTags.length > 0 && <div className="flex flex-wrap justify-end gap-px pl-2.5" aria-label="Tags">
        {userTags.map(tag => {
          const negative = tag.kategorie === 'LIZENZ_NEGATIV';
          return <span key={tag.id} title={tag.name} aria-label={tag.name}
            className={cn('max-w-full rounded-none px-2.5 py-1.5 text-[10px] font-semibold leading-tight tracking-wide text-white break-words',
              negative ? 'bg-[#342328]' : 'bg-[#861722]')}>
            {negative && '− '}{tagAbbreviation(tag)}
          </span>;
        })}

      </div>}
      </div>
    </button>
  );
}
